module.exports = function () {
  return "<div class=\"vocabulary\"></div>";
};